import { render, staticRenderFns } from "./ActiveSuspensionLeft.vue?vue&type=template&id=f953ff3c&scoped=true&"
import script from "./ActiveSuspensionLeft.vue?vue&type=script&lang=js&"
export * from "./ActiveSuspensionLeft.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSuspensionLeft.vue?vue&type=style&index=0&id=f953ff3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f953ff3c",
  null
  
)

export default component.exports